import React, { SVGProps } from 'react';

const LetterX = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M1.82955 0.818182L4.45455 5.05398H4.53409L7.15909 0.818182H8.6108L5.40909 5.90909L8.6108 11H7.15909L4.53409 6.84375H4.45455L1.82955 11H0.377841L3.65909 5.90909L0.377841 0.818182H1.82955Z"
      fill="currentColor"
    />
  </svg>
);

export default LetterX;
